export const URLAPISUBIDA = 'https://narinosouvenirs.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://narinosouvenirs.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://narinosouvenirs.com/notis/'

export const URLAPISUBIDAPDF = 'https://narinosouvenirs.com/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://narinosouvenirs.com/notis/'